import styled from 'styled-components';

import media from '../../theme/media';

export const PinInputUnderline = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    /* TODO: no black (emphasised) border token for focus — using --fill_primary_default, like the primary button. */
    background: ${(props) => (props.$isError ? 'var(--border_error_default)' : 'var(--fill_primary_default)')};
    opacity: ${(props) => (props.$isError ? 1 : 0)};
`;
export const PinInputContainer = styled.div`
    position: relative;
    overflow: hidden;
    border-radius: 6px;

    input {
        width: 38px;
        height: 54px;
        border: 1px solid var(--border_primary_main_default);
        border-radius: 6px;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
        background: var(--bg_primary_main_default);
        color: var(--text_primary_main_default);
        caret-color: var(--text_primary_main_default);

        font-family: var(--font-header), sans-serif;

        ${media.tablet720} {
            width: 63px;
            height: 84px;
            border-radius: 8px;
        }
    }

    input:focus + ${PinInputUnderline} {
        opacity: 1;
    }
`;

export const PinContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 16px;
    column-gap: 8px;

    ${media.tablet720} {
        margin-top: 24px;
        column-gap: 16px;
    }

    &:after {
        content: '-';
        position: absolute;
        font-size: 24px;
    }

    ${PinInputContainer}:nth-child(3) {
        margin-right: 24px;

        ${media.tablet720} {
            margin-right: 32px;
        }
    }
`;
